<template>
  <div class="page">
    <div class="home-group">
      <van-tabs v-model="active" :animated="enableAnimate" swipeable>
        <van-tab v-for="item in cList" :key="item.text">
          <component class="home-group-item" :is="item.component"></component>
        </van-tab>
      </van-tabs>
    </div>

    <van-tabbar v-model="active" :fixed="false">
      <van-tabbar-item
        class="tabbar"
        v-for="(item, index) in cList"
        :class="index == active ? 'active' : 'inactive'"
        :key="item.text"
      >
        {{ item.text }}
        <template #icon>
          <svg class="vxm-icon" aria-hidden="true" size="26">
            <use
              :xlink:href="'#vxm-icon-' + (index === active ? item.activeIcon : item.icon)"
            ></use>
          </svg>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import List from './child/list.vue';
import Mine from './child/mine.vue';
export default {
  name: 'face-home',
  components: {
    List,
    Mine,
  },
  data() {
    return {
      pageTitle: '脸到',
      active: parseInt(this.$vxRoute.params.active),
      enableAnimate: false,
      cList: [
        {
          text: '签到/退记录',
          icon: 'qiandaojilu0',
          activeIcon: 'qiandaojilu1',
          component: List,
        },
        {
          text: '我的',
          icon: 'wode0',
          activeIcon: 'wode1',
          component: Mine,
        },
      ],
    };
  },
  mounted() {
    this.enableAnimate = true;
  },
  watch: {
    active: {
      immediate: true,
      handler(nv, ov) {
        let c = this.cList[this.active || 0];
        this.pageTitle = c.pageTitle || c.text;
        app.tool.setDocTitle(this.pageTitle);

        if (ov !== undefined) {
          this.$router.replace({
            params: {
              active: nv,
            },
            query: this.$vxRoute.query,
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-tabs {
  height: 100%;
  .van-tabs__wrap {
    display: none;
  }
  .van-tabs__content {
    height: 100%;
  }
}
.page {
  display: flex;
  flex-direction: column;
}
.home-group {
  flex: 1;
  .home-group-item {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 1;
  }
}
.tabbar {
  font-size: var(--fs-xs);
  &.active {
    color: var(--c1);
  }
  &.inactive {
    color: var(--g6);
  }
}
</style>